import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AddTicketModel } from 'src/sb-modules/Frontend-form-field-module/common/models/add-ticket-model.model';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root',
})
export class TicketService {
    constructor(private httpClient: HttpClient) {}

    create(ticket: AddTicketModel): Observable<number> {
        return this.httpClient.post<number>(environment.apiInboxUrl + 'tickets/internal', ticket);
    }

    send(ticket: AddTicketModel): Observable<number> {
        return this.httpClient.post<number>(environment.apiInboxUrl + 'tickets/v2', ticket, { withCredentials: true });
    }
}
